import { render, staticRenderFns } from "./PreviewOffering.vue?vue&type=template&id=a319e8f8&scoped=true"
import script from "./PreviewOffering.vue?vue&type=script&lang=js"
export * from "./PreviewOffering.vue?vue&type=script&lang=js"
import style0 from "./PreviewOffering.vue?vue&type=style&index=0&id=a319e8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a319e8f8",
  null
  
)

export default component.exports